import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreateMassTemplateMessageListService=async(data)=>{
    try {
        const result = await publicPost(`api/admin/templatetargetlist/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateMassTemplateMessageListService=async(data,id)=>{
    try {
        const result = await put(`api/admin/templatetargetlist/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateReTargetFinalCheckCustomerService=async(data,id)=>{
    try {
        const result = await put(`api/admin/templatetargetlist/update_final_check/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetMassTemplateMessageListService=async(page)=>{
    try {
        const result = await get(`api/admin/templatetargetlist/get?page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetVoiceCallListDetailService=async(id)=>{
    try {
        const result = await get(`api/admin/templatetargetlist/get_detail/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteMassTemplateMessageListService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/templatetargetlist/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetTemplateMessageListAnsweredService=async(page,from_date,to_date,type)=>{
    try {
        const result = await get(`api/admin/templatetargetlist/get_all_template_target_list_answered?page=${page}&from_date=${from_date}&to_date=${to_date}&type=${type}`);
        return result;
    } catch (err) {
        return err.response;
    }
}


export const UpdateTemplateMessageListAnsweredService=async(id)=>{
    try {
        const result = await put(`api/admin/templatetargetlist/update_template_target_list/${id}`, {});
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateTemplateMessageListAnsweredMassService=async()=>{
    try {
        const result = await put(`api/admin/templatetargetlist/update_all_template_target_list`,{});
        return result;
    } catch (err) {
        return err.response;
    }
}